import React from 'react'
import { Box } from 'theme-ui'
import ContentBoxes from '../components/ContentBoxes/v2/ContentBoxes'

export default function ContentBoxesV1(props) {
  const {
    options,
    // businessData,
    variantName
    // configData,
    // locationIndex,
  } = props

  const { containerStyles } = options

  const variant = variantName ? variantName : 'contentBoxesV2'
  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  return (
    <Box variant={`${variant}.container`} sx={styles}>
      <ContentBoxes {...props} variantName={variant} />
    </Box>
  )
}
